var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"google-auth-button",attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('img',{staticClass:"google-icon",attrs:{"src":require('@/assets/svg/google-logo.svg'),"alt":"Google"}}),_c('span',{staticClass:"google-button-text"},[_vm._v("Continue with Google")])])
}
var staticRenderFns = []

export { render, staticRenderFns }